import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_finance_info_component = _resolveComponent("finance-info-component")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref: "dialogRef",
    "no-shake": "",
    "full-width": "",
    onHide: _ctx.onDialogHide
  }, {
    default: _withCtx(() => [
      _createVNode(_component_finance_info_component, {
        "bill-id": _ctx.existingBillId,
        "is-payment": _ctx.isPayment,
        onClose: _cache[0] || (_cache[0] = (payload) => _ctx.handleClose(payload))
      }, null, 8, ["bill-id", "is-payment"])
    ]),
    _: 1
  }, 8, ["onHide"]))
}